/**
 * GET `admin/usage` — расход по всем клиникам за месяц: основа для цен и
 * пакетов (сколько диалогов, токенов и платных WhatsApp съедает клиника).
 */

import {apiEnabled, http} from '@services/utils';

import {mockPlatformUsage} from '../mocks';
import {asNum, asObj, asStr, toRateCard, toTotals} from '../toUsage';
import type {PlatformUsage} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

/** `period` — месяц YYYY-MM */
export const getPlatformUsage = async (period: string): Promise<PlatformUsage> => {
  if (!apiEnabled) {
    await sleep(250);
    return mockPlatformUsage(period);
  }
  const r = asObj(await http('admin/usage', {params: {period}, skipCaseConversion: true}));
  return {
    period: asStr(r.period) || period,
    clinics: (Array.isArray(r.clinics) ? r.clinics : []).map((c) => {
      const x = asObj(c);
      return {
        clinicId: asStr(x.clinicId),
        clinicName: asStr(x.clinicName) || '—',
        totals: toTotals(x.totals),
        estimatedCostTiyin: asNum(x.estimatedCostTiyin),
      };
    }),
    totals: toTotals(r.totals),
    estimatedCostTiyin: asNum(r.estimatedCostTiyin),
    rateCard: toRateCard(r.rateCard),
  };
};
